import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import _ from 'lodash'
import { connect } from 'react-redux'
import { isValidElementType } from 'react-is'
import SidebarNavigation, { isSidebarNavShow, getSidebarNavItems } from './Navigation/SidebarNavigation'
import { fetchCredential } from '../actions'
import { getDefaultRoutePath } from '../utils/getDefaultPath'
import PrivateRoute from './PrivateRoute'

class MainContent extends Component {

  componentDidMount() {
    this.props.fetchCredential()
    this.props.dispatchAppInitAction()
  }

  renderCommonAddons() {
    const { commonAddons } = this.props
    if (!commonAddons || !Array.isArray(commonAddons) || commonAddons.length === 0) {
      return null
    }
    const addons = []
    const pushItem = (item) => {
      if (isValidElementType(item)) {
        const Item = item
        addons.push(<Item />)
      }
      else {
        // eslint-disable-next-line no-console
        console.error('something in commonAddons is not supported', commonAddons)
        throw new Error('something in commonAddons is not supported')
      }
    }
    commonAddons.forEach(pushItem)

    return addons.map((item, i) => (
      <Fragment key={`${item.id || item.name || item.constructor.displayName || 'item'}-${i}`}
      >{item}</Fragment>
    ))
  }

  createRoutes({ path, component, redirectTo, subMenu, isPrivate, authPath }, defaultRoute) {
    const routes = []
    if (subMenu) {
      for (const subRoute of subMenu) {
        routes.push(...this.createRoutes(subRoute, defaultRoute))
      }
    }
    if (_.isString(redirectTo)) {
      const render = () => (
        <Redirect to={redirectTo === '' ? {
          pathname: defaultRoute,
          search: window.location.search
        } : {
          pathname: redirectTo,
          search: window.location.search
        }} />
      )
      path == null ? routes.push(<Route key='' render={render} />) : routes.push(<Route
        key={path}
        exact path={path}
        render={render}
      />)
    }
    else {
      if (path == null) {
        routes.push(<Route key='' component={component}/>)
      }
      else if (isPrivate) {
        routes.push(<PrivateRoute key={path} path={path} authPath={authPath} component={component}/>)
      }
      else {
        routes.push(<Route key={path} path={path} component={component}/>)
      }
    }
    return routes
  }

  render() {
    const { routes, location, appBarProps, showBadgeFooter } = this.props
    const defaultRoute = getDefaultRoutePath(routes)
    const className = showBadgeFooter ? 'wrap wrap-with-footer' : 'wrap'
    const generatedRoutes = []
    for (const route of routes) {
      generatedRoutes.push(...this.createRoutes(route, defaultRoute))
    }
    return (<div style={ appBarProps.hideAppBar ? { paddingTop: 0 } : {}} className={className}>
      {!appBarProps.isVertical && isSidebarNavShow(routes, location.pathname) && (
        <SidebarNavigation location={location} navItems={getSidebarNavItems(routes)} />
      )}
      <Switch>
        {defaultRoute !== '/' &&
          <Route
            exact path='/'
            render={() => (
              <Redirect to={{
                pathname: defaultRoute,
                search: location.search
              }} />
            )}
          />
        }
        <Route
          exact path='/index.html'
          render={() => (
            <Redirect to={{
              pathname: defaultRoute,
              search: location.search
            }} />
          )}
        />
        <Route
          exact path='/logout'
          render={() => {
            localStorage.setItem('selectedAccount', '') // will use default csp account
            window.location.replace('/saml/logout')
            return null
          }}
        />
        { generatedRoutes }
      </Switch>
      <div className='app-common-addons'>
        {this.renderCommonAddons()}
      </div>
    </div>)
  }

}

MainContent.propTypes = {
  routes: PropTypes.array.isRequired,
  fetchCredential: PropTypes.func,
  appInitAction: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  commonAddons: PropTypes.array,
  dispatchAppInitAction: PropTypes.func,
  selectedAccount: PropTypes.number,
  location: PropTypes.object,
  appBarProps: PropTypes.object,
  showBadgeFooter: PropTypes.bool,
}

const mapStateToProps = ({ selectedAccount, appBarProps }) => {
  return {
    ...appBarProps,
    selectedAccount
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchCredential: () => dispatch(fetchCredential()),
  dispatchAppInitAction: (action) => dispatch(action)
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  dispatchAppInitAction: () =>
    dispatchProps.dispatchAppInitAction(ownProps.appInitAction || { type: 'APP_INIT' })
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(MainContent))

